// JWT utility functions for decoding tokens
// Note: This is client-side decoding only for extracting non-sensitive data
// Server-side validation is still required for security

export const decodeJwt = (token) => {
  try {
    // JWT tokens have 3 parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    // Add padding if needed for base64url
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
    const decodedPayload = atob(paddedPayload.replace(/-/g, '+').replace(/_/g, '/'));
    
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return null;
  }
};

export const getSessionIdFromToken = (token) => {
  if (!token) return null;
  
  const decoded = decodeJwt(token);
  if (!decoded || !decoded.session_id) {
    return null;
  }
  
  return decoded.session_id;
};
